"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect, useState } from "react";

// global-error replaces the root layout, so there is no intl provider to read
// from — the copy has to come from here. It used to be hard-coded Russian, which
// is wrong on getmintai.app and on mint24.app/en alike. English is the default
// and Russian is used only when the URL says so.
const COPY = {
  en: { title: "Something went wrong", retry: "Try again" },
  ru: { title: "Что-то пошло не так", retry: "Попробовать снова" },
};

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Resolved after mount: the server render has no request locale here, and
  // guessing one would flash the wrong language.
  const [lang, setLang] = useState<"en" | "ru">("en");

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    if (/^\/ru(\/|$)/.test(window.location.pathname)) setLang("ru");
  }, []);

  const copy = COPY[lang];

  return (
    <html lang={lang}>
      <body>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "system-ui, sans-serif" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>{copy.title}</h2>
          <button
            onClick={reset}
            style={{ padding: "0.5rem 1.5rem", borderRadius: "0.5rem", border: "none", background: "#5B4CFF", color: "white", cursor: "pointer", fontSize: "1rem" }}
          >
            {copy.retry}
          </button>
        </div>
      </body>
    </html>
  );
}
